// TableEventBus.js - Event system for table communication
class TableEventBus {
  constructor() {
    this.events = {};
  }

  // Subscribe to events
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);

    // Return unsubscribe function
    return () => {
      this.events[eventName] = this.events[eventName].filter(
        cb => cb !== callback
      );
    };
  }

  // Emit events
  emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(callback => callback(data));
    }
  }

  // Remove all listeners for an event
  off(eventName) {
    delete this.events[eventName];
  }
}

// Create singleton instance
export const tableEvents = new TableEventBus();

// Event types
export const TABLE_EVENTS = {
  STATUS_UPDATE_OPTIMISTIC: 'status_update_optimistic',
  STATUS_UPDATE_SUCCESS: 'status_update_success',
  STATUS_UPDATE_FAILED: 'status_update_failed',
  REFRESH_ALL_TABLES: 'refresh_all_tables'
};
